// test2467
(2467 && 0);
